import { render, staticRenderFns } from "./knowledgeSubcategoryCard.vue?vue&type=template&id=62bd1117&"
import script from "./knowledgeSubcategoryCard.vue?vue&type=script&lang=js&"
export * from "./knowledgeSubcategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports